import { z } from 'zod';
// =========================================================
// BOM (Bill of Materials) de un producto ensamblado de BC — página
// "Assembly BOM" ("L.M. de ensamblado"), publicada en BC como el web
// service `L_M_de_ensamblado_Excel`.
//
// Sirve para mostrar la composición real de un producto (materiales +
// recurso, cada uno con su cantidad por unidad del producto) — necesario
// en coladas manuales (Fiori) porque ahí no hay batches de los que derivar
// consumo real; la única forma de saber "qué se rebaja de inventario" es
// leer la fórmula del producto directo desde BC y multiplicar por los m³.
// =========================================================
export const LineaBomBCSchema = z.object({
    tipo: z.enum(['item', 'recurso']),
    codigo: z.string(),
    descripcion: z.string(),
    unidad: z.string(),
    /** Cantidad de este componente por 1 unidad del producto padre. */
    cantidad_por_unidad: z.number(),
});
export const ListaBomBCResponseSchema = z.object({
    lineas: z.array(LineaBomBCSchema),
});
//# sourceMappingURL=bc-bom.js.map